// extracted by mini-css-extract-plugin
module.exports = {"userProfileWrapper":"user-profile_userProfileWrapper__kqcsL","profileLink":"user-profile_profileLink__oFPmB","profileLinkText":"user-profile_profileLinkText__OOAnL"};